const Checkbox = ({ label, onUpdate, qaClasses, checked }) => {
  return (
    <div class='article-creator__sidebar--checkbox'>
      <label>
        <input type='checkbox' {...(checked && { checked: checked })} class={qaClasses} onChange={(e) => onUpdate(e.target.checked)} />
        {label}
      </label>
    </div>
  )
}

export default Checkbox
